import { Sizes } from '../../constants/size';
import type { IconProps } from '../../types/icon-props';

export const Menu = (props: IconProps) => {
  const { size = 'md', fill = 'var(--grey-1)', stroke = 'var(--grey-1)', ...rest } = props;

  return (
    <svg
      width={Sizes[size]}
      height={Sizes[size]}
      viewBox="0 0 16 16"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <g id="vuesax/outline/menu">
        <g id="menu">
          <path
            id="Vector"
            d="M14 5.16663H2C1.72667 5.16663 1.5 4.93996 1.5 4.66663C1.5 4.39329 1.72667 4.16663 2 4.16663H14C14.2733 4.16663 14.5 4.39329 14.5 4.66663C14.5 4.93996 14.2733 5.16663 14 5.16663Z"
          />
          <path
            id="Vector_2"
            d="M14 8.5H2C1.72667 8.5 1.5 8.27333 1.5 8C1.5 7.72667 1.72667 7.5 2 7.5H14C14.2733 7.5 14.5 7.72667 14.5 8C14.5 8.27333 14.2733 8.5 14 8.5Z"
          />
          <path
            id="Vector_3"
            d="M14 11.8334H2C1.72667 11.8334 1.5 11.6067 1.5 11.3334C1.5 11.06 1.72667 10.8334 2 10.8334H14C14.2733 10.8334 14.5 11.06 14.5 11.3334C14.5 11.6067 14.2733 11.8334 14 11.8334Z"
          />
        </g>
      </g>
    </svg>
  );
};

Menu.displayName = 'Menu';
